module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-card-9"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showBullets) ? _c('div', {
    staticClass: "columns shrink align-self-middle show-for-medium"
  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns n1 large-2 small-12"
  }, [_vm._t("n1")], 2), _c('div', {
    staticClass: "columns n2 align-self-middle small-12 medium-6 large-2"
  }, [_vm._t("n2")], 2), _c('div', {
    staticClass: "columns n3 align-self-middle small-6 large-1"
  }, [_vm._t("n3")], 2), _c('div', {
    staticClass: "columns n4 align-self-middle small-6 large-1"
  }, [_vm._t("n4")], 2), _c('div', {
    staticClass: "columns n5 align-self-middle small-6 large-1"
  }, [_vm._t("n5")], 2), _c('div', {
    staticClass: "columns n6 align-self-middle large-1"
  }, [_vm._t("n6")], 2), _c('div', {
    staticClass: "columns n7 align-self-middle large-1"
  }, [_vm._t("n7")], 2), _c('div', {
    staticClass: "columns n8 align-self-middle small-12 large-1"
  }, [_vm._t("n8")], 2), _c('div', {
    staticClass: "columns n9 align-self-middle large-2"
  }, [_vm._t("n9")], 2)])]), (_vm.showAction) ? _c('div', {
    staticClass: "columns shrink align-self-middle show-for-medium"
  }, [_vm._t("actionPage")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0cfa7d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Card9.vue
// module id = 2517
// module chunks = 1